import { Suspense } from "react"

interface AuthLayoutProps {
  children: React.ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return <Suspense fallback={null}>{children}</Suspense>
}
